import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import "../styles/dataTable.css";
import searchIcon from '../assets/images/search_icon.svg';
import arrowIcon from '../assets/images/Arrow.svg';
import upwardArrowIcon from '../assets/images/upward_arrow.svg';
import editIcon from '../assets/images/edit_icon.svg';
import UpdatePackageInPage from '../pages/UpdatePackageInPage';

const FiltterPage = () => {
  const [vendors, setVendors] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const filterType = location.state?.filterType || "";

  // Overlay / Modal States
  const [showUpdatePackage, setShowUpdatePackage] = useState(false);
  const [cardId, setCardId] = useState(null);

  const containerRef = useRef(null);
  const containerUpdateRef = useRef(null);

  // Helper to safely get Vendor ID from localStorage
  const getVendorId = () => {
    try {
      const vendorData = localStorage.getItem("vendor");
      return vendorData ? JSON.parse(vendorData)?.id : null;
    } catch (error) {
      console.error("Error reading vendor from localStorage:", error);
      return null;
    }
  };

  // Table State
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const filteredData = vendors.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  if (sortField) {
    filteredData.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];

      if (typeof valA === "number") {
        return sortOrder === "asc"
          ? valA - valB
          : valB - valA;
      } else {
        return sortOrder === "asc"
          ? String(valA || "").localeCompare(String(valB || ""))
          : String(valB || "").localeCompare(String(valA || ""));
      }
    });
  }

  const totalPages =
    Math.ceil(filteredData.length / entriesPerPage) || 1;

  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(1);
    }
  }, [search, entriesPerPage, totalPages]);

  // Sort Toggle Handler
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) =>
        prev === "asc" ? "desc" : "asc"
      );
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  useEffect(() => {
    fetchVendors();
  }, [filterType, showUpdatePackage]);

  // Fetch API Data
  const fetchVendors = async () => {
    const vendorId = getVendorId();

    if (!vendorId) {
      console.error("Vendor ID not found in localStorage");
      toast.error("Vendor ID not found. Please log in again.");
      return;
    }

    try {
      let response;

      if (filterType === "total") {
        response = await api.get(
          `api/Vendorlist/getlistAll/${vendorId}`
        );
      } else if (
        filterType === "active" ||
        filterType === "live"
      ) {
        response = await api.get(
          `api/Vendorlist/livepackage/${vendorId}`
        );
      } else if (
        filterType === "inactive" ||
        filterType === "expired"
      ) {
        response = await api.get(
          `api/Vendorlist/expiredpackages/${vendorId}`
        );
      } else {
        response = await api.get(
          `api/Vendorlist/productlist/${vendorId}`
        );
      }

      setVendors(response.data?.data || []);
    } catch (error) {
      console.error(`Error fetching packages:`, error);
      toast.error("Failed to fetch packages data.");
    }
  };

  const handlePackageUpdate = (id) => {
    setCardId(id);
    setShowUpdatePackage(true);
  };

  // Helper function to check if package is expired or live
  const isPackageExpired = (row) => {
    if (row.status !== undefined && row.status !== null) {
      return (
        String(row.status).toLowerCase() === "expired" ||
        String(row.status).toLowerCase() === "inactive" ||
        row.status === 0 ||
        row.status === "0"
      );
    }

    if (row.is_expired !== undefined) {
      return Boolean(row.is_expired);
    }

    return (
      filterType === "expired" ||
      filterType === "inactive"
    );
  };

  return (
    <div
      style={{
        position: 'relative',
        height:
           showUpdatePackage
            ? "100vh"
            : 'auto',
        overflow: 'hidden'
      }}
    >
      <div
        class="table-container"
        style={{
          opacity:
          showUpdatePackage
         
        }}
      >

        {/* Page Title */}
        <h2 class="page-title"
          style={{
            fontWeight: 700,
            margin: "20px 20px "
          }}
        >
          {filterType
            ? filterType.charAt(0).toUpperCase() +
              filterType.slice(1)
            : "Total"}{" "}
          Packages
        </h2>

        {/* Custom Table Header Controls */}
        <div
          className="table-header"
        >
          <div className="table-pagenation-controls">

            {/* Search */}
            <div className="search-container">
              <input
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                placeholder="search"
              />

              <img
                src={searchIcon}
                alt="search-icon"
                className="search-icon"
              />
            </div>

            {/* Entries */}
            <div className="entries-container">
              <label htmlFor="noOfEntries">
                Show:{" "}
              </label>

              <select
                value={entriesPerPage}
                id="noOfEntries"
                onChange={(e) =>
                  setEntriesPerPage(
                    Number(e.target.value)
                  )
                }
              >
                <option value={10}>
                  10 Entries per page
                </option>

                <option value={50}>
                  50 Entries per page
                </option>

                <option value={100}>
                  100 Entries per page
                </option>
              </select>
            </div>

          </div>
        </div>

        {/* Table */}
        <table
          width="100%"
          cellPadding="15"
          className="table-no-outer-border"
        >
          <thead>
            <tr>

              {/* Package Name */}
              <th
                onClick={() =>
                  handleSort("packagename")
                }
              >
                <div className='name-container'>
                  Package Name

                  <div className='sort-arrow-container'>

                    <img
                      src={upwardArrowIcon}
                      alt="upward-arrow"
                      style={{
                        opacity:
                          sortField === "packagename"
                            ? (
                              sortOrder === "asc"
                                ? 1
                                : 0.5
                            )
                            : 0.5
                      }}
                    />

                    <img
                      src={upwardArrowIcon}
                      alt="upward-arrow"
                      style={{
                        transform:
                          'rotateX(180deg)',
                        marginTop: "5px",
                        opacity:
                          sortField === "packagename"
                            ? (
                              sortOrder === "asc"
                                ? 0.5
                                : 1
                            )
                            : 0.5
                      }}
                    />

                  </div>
                </div>
              </th>

              {/* Duration */}
              <th
                onClick={() =>
                  handleSort("duration")
                }
              >
                <div className='name-container'>
                  Duration
                </div>
              </th>

              {/* Price */}
              <th
                onClick={() =>
                  handleSort("price")
                }
              >
                <div className='name-container'>
                  Price
                </div>
              </th>

              {/* Image */}
              <th>
                Image
              </th>

              {/* Status - HIDDEN ONLY ON TOTAL PAGE */}
              {filterType !== "total" && (
                <th>
                  Status
                </th>
              )}

              {/* Action */}
              <th>
                Action
              </th>

            </tr>
          </thead>

          <tbody>

            {paginatedData.length > 0 ? (

              paginatedData.map((row, i) => {

                const expired =
                  isPackageExpired(row);

                return (
                  <tr key={row.id || i}>

                    {/* Package Name */}
                    <td>
                      {row.packagename ||
                        row.name ||
                        "N/A"}
                    </td>

                    {/* Duration */}
                    <td>
                      {row.duration || "N/A"}
                    </td>

                    {/* Price */}
                    <td>
                      ₹{" "}
                      {parseFloat(
                        row.price || 0
                      ).toLocaleString('en-IN')}
                    </td>

                    {/* Image */}
                    <td>
                      {row.image_path ||
                      row.logo_image_path ? (

                        <img
                          style={{
                            width: '90px',
                            height: '40px',
                            borderRadius: '4px'
                          }}
                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${row.image_path || row.logo_image_path}`}
                          alt="Package"
                        />

                      ) : (
                        "No Image"
                      )}
                    </td>

                    {/* Status - HIDDEN ONLY ON TOTAL PAGE */}
                    {filterType !== "total" && (
                      <td>
                        <span
                          style={{
                            color: expired
                              ? "#d9534f"
                              : "#5cb85c",
                            fontWeight: "600"
                          }}
                        >
                          {expired
                            ? "Expired"
                            : "Live"}
                        </span>
                      </td>
                    )}

                    {/* Action */}
                    <td className='text-center align-middle'>
                      <button
                        className='edit-button'
                        onClick={() =>
                          handlePackageUpdate(row.id)
                        }
                      >
                        <img
                          src={editIcon}
                          alt="editIcon"
                        />

                        Edit
                      </button>
                    </td>

                  </tr>
                );
              })

            ) : (

              <tr>
                <td
                  colSpan={
                    filterType === "total"
                      ? 5
                      : 6
                  }
                  style={{
                    textAlign: "center"
                  }}
                >
                  No packages found
                </td>
              </tr>

            )}

          </tbody>
        </table>

        {/* Custom Pagination */}
        <div className="custom-pagination">
          <div className="pagination-controls">

            {/* Prev Arrow */}
            <button
              onClick={() =>
                setCurrentPage(prev =>
                  Math.max(prev - 1, 1)
                )
              }
              disabled={currentPage === 1}
              style={{
                margin: "0 5px",
                padding: "5px 10px",
                background: "#fff",
                border: "none",
                cursor:
                  currentPage === 1
                    ? "not-allowed"
                    : "pointer"
              }}
            >
              <img
                src={arrowIcon}
                alt="arrow-icon"
                style={{
                  opacity:
                    currentPage === 1
                      ? "0.5"
                      : "1"
                }}
              />
            </button>

            {/* Page Numbers */}
            {Array.from(
              { length: totalPages },
              (_, i) => i + 1
            ).map((page) => (

              <button
                key={page}
                onClick={() =>
                  setCurrentPage(page)
                }
                style={{
                  margin: "0 5px",
                  padding: "5px 10px",
                  background:
                    currentPage === page
                      ? "#D9D9D9"
                      : "#fff",
                  color:
                    currentPage === page
                      ? "black"
                      : "#00000075",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
              >
                {page}
              </button>

            ))}

            {/* Next Arrow */}
            <button
              onClick={() =>
                setCurrentPage(prev =>
                  Math.min(
                    prev + 1,
                    totalPages
                  )
                )
              }
              disabled={
                currentPage === totalPages
              }
              style={{
                margin: "0 5px",
                padding: "5px 10px",
                background: "#fff",
                border: "none",
                cursor:
                  currentPage === totalPages
                    ? "not-allowed"
                    : "pointer"
              }}
            >
              <img
                src={arrowIcon}
                alt="arrow-icon"
                style={{
                  opacity:
                    currentPage === totalPages
                      ? "0.5"
                      : "1",
                  transform:
                    'rotateY(180deg)'
                }}
              />
            </button>

          </div>
        </div>

      </div>

      {/* Update Package */}
      {showUpdatePackage && (
        <UpdatePackageInPage
          setShowUpdatePackage={
            setShowUpdatePackage
          }
          containerUpdateRef={
            containerUpdateRef
          }
          id={cardId}
        />
      )}

    </div>
  );
};

export default FiltterPage;